import React from 'react'
import { graphql, useStaticQuery } from "gatsby"

import type { HeadProps } from "gatsby"
import type { PageDataProps } from '../drupal'

type StaticQueryProps = {
    site: {
        siteMetadata: {
            name: string
            description: string
            defaultLanguage: string
        }
    }
}

/**
 * Delete attributes when value is null.
 *
 * @param attributes metatag attributes.
 */
function cleanMetatagAttributes(attributes: { [key: string]: any }) {
    Object.keys(attributes).forEach(key => attributes[key] == null && delete attributes[key])

    return attributes
}

/**
 * Render metatags from Drupal data.
 *
 * @param metatags
 */
function renderMetatags(metatags: PageDataProps['node']['metatag_normalized']) {
    return metatags.map(({ tag, attributes }, index) =>
        React.createElement(tag, { key: index, ...cleanMetatagAttributes(attributes) })
    )
}

export function Head({ data: { node } }: HeadProps<PageDataProps>) {
    const { site: { siteMetadata } }: StaticQueryProps = useStaticQuery(graphql`
        query HeadQuery {
            site {
                siteMetadata {
                    name
                    description
                    defaultLanguage
                }
            }
        }
    `)

    return (
        <>
            <html lang={node.langcode || siteMetadata.defaultLanguage} />
            <title>{`${node.title} | ${siteMetadata.name}`}</title>

            {/* Preload webfonts */}
            <link
                rel="preload"
                href={require('../styles/webfonts/399019_0_0.woff2').default}
                as="font"
                crossOrigin="anonymous"
            />
            <link
                rel="preload"
                href={require('../styles/webfonts/399019_1_0.woff2').default}
                as="font"
                crossOrigin="anonymous"
            />

            {/* drupal metatags */}
            {renderMetatags(node.metatag_normalized)}
        </>
    )
}